export default {"src":"/_next/static/media/icon.7c5daa53.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};